import * as R from '../../Router/routes';
import {
  AsyncActiveLoan,
  AsyncLogin,
  AsyncRepeatedLoan,
} from '../../Router/Router';
import { Helmet } from 'react-helmet-async';
import { RouteComponentProps } from '@reach/router';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer/Footer';
import Heading from '../../components/Heading/Heading';
import Link from '../../components/Link/Link';
import Logo from 'assets/icons/logo.svg?react';
import Paragraph from '../../components/Paragraph/Paragraph';
import styles from './NotFound.module.scss';
import Tracked from '../../customAnalytics/components/Tracked';

export default function NotFound(props: RouteComponentProps) {
  const { t } = useTranslation('not_found');

  useEffect(() => {
    AsyncActiveLoan.preload();
    AsyncRepeatedLoan.preload();
    AsyncLogin.preload();
  }, []);

  const LINKS = [
    {
      title: t('how_it_works'),
      url: 'https://www.vivus.es/como-funciona',
    },
    {
      title: t('offer'),
      url: 'https://www.vivus.es/ofertas/prestamo-300-euros',
    },
    {
      title: t('blog'),
      url: 'https://www.vivus.es/blog',
    },
    {
      title: t('faq'),
      url: 'https://www.vivus.es/faq',
    },
    {
      title: t('contacts'),
      url: 'https://www.vivus.es/contacto',
    },
    {
      title: t('about_us'),
      url: 'https://www.vivus.es/informacion-de-prestamos/quienes-somos',
    },
  ];

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{t('html_title')}</title>
      </Helmet>

      <header className={styles.header} data-test="notFound">
        <div>
          <Tracked description="Back link">
            <Link to={R.ACTIVE_LOAN} data-test="notFound-back-link">
              <Logo />
            </Link>
          </Tracked>
        </div>
      </header>

      <main className={styles.main}>
        <Heading size="l" dataTest="notFound-title">
          {t('title')}
        </Heading>

        <Heading className={styles.subtitle} dataTest="notFound-subtitle">
          {t('subtitle')}
        </Heading>

        <Paragraph className={styles.description} dataTest="notFound-desc">
          {t('description')}
        </Paragraph>

        {LINKS.map(({ title, url }, index) => (
          <Link
            className={styles.link}
            size="m"
            external
            to={url}
            dataTest={`notFound-links-${index}-item`}
          >
            {title}
          </Link>
        ))}
      </main>

      <Footer />
    </div>
  );
}
